var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8609 1.86166C12.5204 1.521 12.1161 1.25076 11.6711 1.06638C11.2261 0.882008 10.7492 0.787109 10.2675 0.787109C9.78587 0.787109 9.30893 0.882008 8.86396 1.06638C8.41898 1.25076 8.0147 1.521 7.67419 1.86166L6.96753 2.56833L6.26086 1.86166C5.57307 1.17387 4.64022 0.787466 3.66753 0.787466C2.69484 0.787466 1.76199 1.17387 1.07419 1.86166C0.386399 2.54945 7.2471e-09 3.4823 0 4.45499C-7.2471e-09 5.42768 0.386399 6.36053 1.07419 7.04833L1.78086 7.75499L6.96753 12.9417L12.1542 7.75499L12.8609 7.04833C13.2015 6.70782 13.4718 6.30354 13.6561 5.85856C13.8405 5.41359 13.9354 4.93665 13.9354 4.45499C13.9354 3.97333 13.8405 3.4964 13.6561 3.05142C13.4718 2.60645 13.2015 2.20216 12.8609 1.86166Z",
    fill: "#EE2822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.b70053a80624a1abc308b90bca8eab1f.svg";
export { ForwardRef as ReactComponent };